// The Vegetronix reading is an unsigned 12-bit ADC value. This value is first converted to volts and then to volumetric water content (VWC) with units of percent. No sensor calibration is required. Convert the 12-bit ADC value ($rdg in code below) to VWC ($vwc in code below) using the following algorithm:

/*
$vwc = 0.0;
if ( $rdg == 0xFFF )
{
  $vwc = null; // display reading as “invalid”
}
else
{
  $volt = ((float)$rdg)/327.6;

  if ( $volt < 1.1 )
    $vwc = (10.0 * $volt) - 1.0;
  else if ( $volt < 1.3 )
    $vwc = (25.0 * $volt) - 17.5;
  else if ( $volt < 1.82 )
    $vwc = (48.08 * $volt) - 47.5;
  else if ( $volt < 2.2 )
    $vwc = (26.32 * $volt) - 7.89;
  else
    $vwc = (62.5 * $volt) - 87.5;

  if ($vwc < 0.0)
  $vwc = 0.0;
  if ($vwc > 100.0)
  $vwc = 100.0;

  }
*/

export function vegetronix(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const voltage = reading / 327.6
  var vwc = 0

  if (voltage < 1.1) vwc = 10.0 * voltage - 1.0
  else if (voltage < 1.3) vwc = 25.0 * voltage - 17.5
  else if (voltage < 1.82) vwc = 48.08 * voltage - 47.5
  else if (voltage < 2.2) vwc = 26.32 * voltage - 7.89
  else vwc = 62.5 * voltage - 87.5

  if (vwc < 0.0) vwc = 0.0
  if (vwc > 100.0) vwc = 100.0

  return vwc
}
